import { getRootStore } from "@/stores/RootStore";
import { B2BError, toB2BError } from "@/utils/b2bErrors";
/**
 * Единая обёртка kill-switch кабинета корп-админа (UC1130 BR-4, BR-ACC-24/26). Импорт `RootStore` разрешён
 * ТОЛЬКО здесь (+ `components/corp/CorpLayout.tsx`, `pages/corp/CorpProfilePage.tsx`) — `scripts/check-corp-isolation.mjs`.
 */
/** SQLSTATE PostgREST «insufficient privilege» — приходит от `corp_*` при блокировке/удалении админа или компании. */
const KILL_SWITCH_CODE = "42501";
/** Отозванная сессия (D-G3-1): PostgREST отвечает 401 с кодом JWT — тот же kill-switch. */
const REVOKED_CODES = new Set(["42501", "PGRST301", "PGRST302", "PGRST303"]);
/**
 * Перечитывает principal при обнаружении блокировки (fire-and-forget — ошибка `resolvePrincipal`
 * не должна маскировать исходную ошибку кабинета). `corp_whoami()` внутри решит, показывать ли `DeniedPage`.
 */
/** Перечитать субъекта (смена раздела, WP-DSP-3-FIX): отозванный доступ → DeniedPage через resolvePrincipal. */
export const recheckPrincipal = () => getRootStore().authStore.resolvePrincipal({ trigger: "event" });
export const triggerKillSwitch = () => {
    getRootStore()
        .authStore.resolvePrincipal({ trigger: "event" })
        .catch((error) => console.error("corpGuard: resolvePrincipal после kill-switch не выполнен", error));
};
/**
 * Оборачивает промис запроса кабинета: ловит `PostgrestError`/`B2BError` с кодом `42501` → перечитывает
 * principal → пробрасывает `B2BError` дальше (BR-4, UC1130).
 */
export const withCorpGuard = async (promise) => {
    try {
        return await promise;
    }
    catch (error) {
        const b2b = toB2BError(error);
        if (b2b.code && REVOKED_CODES.has(b2b.code))
            triggerKillSwitch();
        throw b2b;
    }
};
/**
 * `corp_my_companies` без строки по активной компании — тот же kill-switch (BR-1, CCR-040): view отдаёт
 * строки всех компаний админа, пустой ответ по `.eq("company_id", …)` означает, что доступ к ней потерян.
 */
export const assertCompanyPresent = (rows) => {
    if (rows.length === 0) {
        triggerKillSwitch();
        throw new B2BError(KILL_SWITCH_CODE, null);
    }
};
/** Алиас — точное имя из формулировки задачи TECH-CORP-008. */
export const assertCompanySummaryPresent = assertCompanyPresent;
